import { IsTenantAvailableOutput } from './IsTenantAvailableOutput';
import { RegisterOutput } from './RegisterOutput';
import { ResetPasswordOutput } from './ResetPasswordOutput';
import { ImpersonateOutput } from './ImpersonateOutput';
import { SwitchToLinkedAccountOutput } from './SwitchToLinkedAccountOutput';
import { throwException } from './Utilities';
var AccountServiceProxy = /** @class */ (function () {
    function AccountServiceProxy(baseUrl) {
        this.beforeSend = undefined;
        this.jsonParseReviver = undefined;
        this.baseUrl = baseUrl ? baseUrl : '';
    }
    /**
     * @param input (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.isTenantAvailable = function (input) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.isTenantAvailableWithCallbacks(input, function (result) { return resolve(result); }, function (exception, _reason) { return reject(exception); });
        });
    };
    /**
     * @param input (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.resolveTenantId = function (input) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.resolveTenantIdWithCallbacks(input, function (result) { return resolve(result); }, function (exception, _reason) { return reject(exception); });
        });
    };
    /**
     * @param input (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.register = function (input) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.registerWithCallbacks(input, function (result) { return resolve(result); }, function (exception, _reason) { return reject(exception); });
        });
    };
    /**
     * @param input (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.sendPasswordResetCode = function (input) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.sendPasswordResetCodeWithCallbacks(input, function (result) { return resolve(result); }, function (exception, _reason) { return reject(exception); });
        });
    };
    /**
     * @param input (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.resetPassword = function (input) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.resetPasswordWithCallbacks(input, function (result) { return resolve(result); }, function (exception, _reason) { return reject(exception); });
        });
    };
    /**
     * @param input (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.sendEmailActivationLink = function (input) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.sendEmailActivationLinkWithCallbacks(input, function (result) { return resolve(result); }, function (exception, _reason) { return reject(exception); });
        });
    };
    /**
     * @param input (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.activateEmail = function (input) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.activateEmailWithCallbacks(input, function (result) { return resolve(result); }, function (exception, _reason) { return reject(exception); });
        });
    };
    /**
     * @param input (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.impersonate = function (input) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.impersonateWithCallbacks(input, function (result) { return resolve(result); }, function (exception, _reason) { return reject(exception); });
        });
    };
    /**
     * @return Success
     */
    AccountServiceProxy.prototype.backToImpersonator = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.backToImpersonatorWithCallbacks(function (result) { return resolve(result); }, function (exception, _reason) { return reject(exception); });
        });
    };
    /**
     * @param input (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.switchToLinkedAccount = function (input) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.switchToLinkedAccountWithCallbacks(input, function (result) { return resolve(result); }, function (exception, _reason) { return reject(exception); });
        });
    };
    AccountServiceProxy.prototype.processIsTenantAvailable = function (xhr) {
        var status = xhr.status;
        var _headers = {};
        if (status === 200) {
            var _responseText = xhr.responseText;
            var result200 = null;
            var resultData200 = (_responseText === '' || _responseText === undefined) ? (xhr.data === null ? null : xhr.data.result) : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? IsTenantAvailableOutput.fromJS(resultData200) : new IsTenantAvailableOutput();
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = xhr.responseText;
            return throwException('An unexpected server error occurred.', status, _responseText, _headers, xhr.data);
        }
        return null;
    };
    AccountServiceProxy.prototype.processResolveTenantId = function (xhr) {
        var status = xhr.status;
        var _headers = {};
        if (status === 200) {
            var _responseText = xhr.responseText;
            var result200 = null;
            var resultData200 = (_responseText === '' || _responseText === undefined) ? (xhr.data === null ? null : xhr.data.result) : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = xhr.responseText;
            return throwException('An unexpected server error occurred.', status, _responseText, _headers, xhr.data);
        }
        return null;
    };
    AccountServiceProxy.prototype.processRegister = function (xhr) {
        var status = xhr.status;
        var _headers = {};
        if (status === 200) {
            var _responseText = xhr.responseText;
            var result200 = null;
            var resultData200 = (_responseText === '' || _responseText === undefined) ? (xhr.data === null ? null : xhr.data.result) : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RegisterOutput.fromJS(resultData200) : new RegisterOutput();
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = xhr.responseText;
            return throwException('An unexpected server error occurred.', status, _responseText, _headers, xhr.data);
        }
        return null;
    };
    AccountServiceProxy.prototype.processSendPasswordResetCode = function (xhr) {
        var status = xhr.status;
        var _headers = {};
        if (status === 200) {
            var _responseText = xhr.responseText;
            return;
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = xhr.responseText;
            return throwException('An unexpected server error occurred.', status, _responseText, _headers, xhr.data);
        }
        return;
    };
    AccountServiceProxy.prototype.processResetPassword = function (xhr) {
        var status = xhr.status;
        var _headers = {};
        if (status === 200) {
            var _responseText = xhr.responseText;
            var result200 = null;
            var resultData200 = (_responseText === '' || _responseText === undefined) ? (xhr.data === null ? null : xhr.data.result) : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResetPasswordOutput.fromJS(resultData200) : new ResetPasswordOutput();
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = xhr.responseText;
            return throwException('An unexpected server error occurred.', status, _responseText, _headers, xhr.data);
        }
        return null;
    };
    AccountServiceProxy.prototype.processSendEmailActivationLink = function (xhr) {
        var status = xhr.status;
        var _headers = {};
        if (status === 200) {
            var _responseText = xhr.responseText;
            return;
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = xhr.responseText;
            return throwException('An unexpected server error occurred.', status, _responseText, _headers, xhr.data);
        }
        return;
    };
    AccountServiceProxy.prototype.processActivateEmail = function (xhr) {
        var status = xhr.status;
        var _headers = {};
        if (status === 200) {
            var _responseText = xhr.responseText;
            return;
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = xhr.responseText;
            return throwException('An unexpected server error occurred.', status, _responseText, _headers, xhr.data);
        }
        return;
    };
    AccountServiceProxy.prototype.processImpersonate = function (xhr) {
        var status = xhr.status;
        var _headers = {};
        if (status === 200) {
            var _responseText = xhr.responseText;
            var result200 = null;
            var resultData200 = (_responseText === '' || _responseText === undefined) ? (xhr.data === null ? null : xhr.data.result) : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ImpersonateOutput.fromJS(resultData200) : new ImpersonateOutput();
            return result200;
        }
        else if (status === 401) {
            var _responseText = xhr.responseText;
            return throwException('A server error occurred.', status, _responseText, _headers, xhr.data);
        }
        else if (status === 403) {
            var _responseText = xhr.responseText;
            return throwException('A server error occurred.', status, _responseText, _headers, xhr.data);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = xhr.responseText;
            return throwException('An unexpected server error occurred.', status, _responseText, _headers, xhr.data);
        }
        return null;
    };
    AccountServiceProxy.prototype.processBackToImpersonator = function (xhr) {
        var status = xhr.status;
        var _headers = {};
        if (status === 200) {
            var _responseText = xhr.responseText;
            var result200 = null;
            var resultData200 = (_responseText === '' || _responseText === undefined) ? (xhr.data === null ? null : xhr.data.result) : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ImpersonateOutput.fromJS(resultData200) : new ImpersonateOutput();
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = xhr.responseText;
            return throwException('An unexpected server error occurred.', status, _responseText, _headers, xhr.data);
        }
        return null;
    };
    AccountServiceProxy.prototype.processSwitchToLinkedAccount = function (xhr) {
        var status = xhr.status;
        var _headers = {};
        if (status === 200) {
            var _responseText = xhr.responseText;
            var result200 = null;
            var resultData200 = (_responseText === '' || _responseText === undefined) ? (xhr.data === null ? null : xhr.data.result) : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SwitchToLinkedAccountOutput.fromJS(resultData200) : new SwitchToLinkedAccountOutput();
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = xhr.responseText;
            return throwException('An unexpected server error occurred.', status, _responseText, _headers, xhr.data);
        }
        return null;
    };
    AccountServiceProxy.prototype.isTenantAvailableWithCallbacks = function (input, onSuccess, onFail) {
        var _this = this;
        var url_ = this.baseUrl + '/api/services/app/Account/IsTenantAvailable';
        url_ = url_.replace(/[?&]$/, '');
        var content_ = JSON.stringify(input);
        abp.ajax.request({
            url: url_,
            method: 'post',
            data: content_,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then(function (xhr) {
            _this.processIsTenantAvailableWithCallbacks(url_, xhr, onSuccess, onFail);
        }, function (xhr) {
            xhr = xhr.response;
            _this.processIsTenantAvailableWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    };
    AccountServiceProxy.prototype.processIsTenantAvailableWithCallbacks = function (_url, xhr, onSuccess, onFail) {
        try {
            var result = this.processIsTenantAvailable(xhr);
            if (onSuccess !== undefined) {
                onSuccess(result);
            }
        }
        catch (e) {
            if (onFail !== undefined) {
                onFail(e, 'http_service_exception');
            }
        }
    };
    AccountServiceProxy.prototype.resolveTenantIdWithCallbacks = function (input, onSuccess, onFail) {
        var _this = this;
        var url_ = this.baseUrl + '/api/services/app/Account/ResolveTenantId';
        url_ = url_.replace(/[?&]$/, '');
        var content_ = JSON.stringify(input);
        abp.ajax.request({
            url: url_,
            method: 'post',
            data: content_,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then(function (xhr) {
            _this.processResolveTenantIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }, function (xhr) {
            xhr = xhr.response;
            _this.processResolveTenantIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    };
    AccountServiceProxy.prototype.processResolveTenantIdWithCallbacks = function (_url, xhr, onSuccess, onFail) {
        try {
            var result = this.processResolveTenantId(xhr);
            if (onSuccess !== undefined) {
                onSuccess(result);
            }
        }
        catch (e) {
            if (onFail !== undefined) {
                onFail(e, 'http_service_exception');
            }
        }
    };
    AccountServiceProxy.prototype.registerWithCallbacks = function (input, onSuccess, onFail) {
        var _this = this;
        var url_ = this.baseUrl + '/api/services/app/Account/Register';
        url_ = url_.replace(/[?&]$/, '');
        var content_ = JSON.stringify(input);
        abp.ajax.request({
            url: url_,
            method: 'post',
            data: content_,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then(function (xhr) {
            _this.processRegisterWithCallbacks(url_, xhr, onSuccess, onFail);
        }, function (xhr) {
            xhr = xhr.response;
            _this.processRegisterWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    };
    AccountServiceProxy.prototype.processRegisterWithCallbacks = function (_url, xhr, onSuccess, onFail) {
        try {
            var result = this.processRegister(xhr);
            if (onSuccess !== undefined) {
                onSuccess(result);
            }
        }
        catch (e) {
            if (onFail !== undefined) {
                onFail(e, 'http_service_exception');
            }
        }
    };
    AccountServiceProxy.prototype.sendPasswordResetCodeWithCallbacks = function (input, onSuccess, onFail) {
        var _this = this;
        var url_ = this.baseUrl + '/api/services/app/Account/SendPasswordResetCode';
        url_ = url_.replace(/[?&]$/, '');
        var content_ = JSON.stringify(input);
        abp.ajax.request({
            url: url_,
            method: 'post',
            data: content_,
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(function (xhr) {
            _this.processSendPasswordResetCodeWithCallbacks(url_, xhr, onSuccess, onFail);
        }, function (xhr) {
            xhr = xhr.response;
            _this.processSendPasswordResetCodeWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    };
    AccountServiceProxy.prototype.processSendPasswordResetCodeWithCallbacks = function (_url, xhr, onSuccess, onFail) {
        try {
            var result = this.processSendPasswordResetCode(xhr);
            if (onSuccess !== undefined) {
                onSuccess(result);
            }
        }
        catch (e) {
            if (onFail !== undefined) {
                onFail(e, 'http_service_exception');
            }
        }
    };
    AccountServiceProxy.prototype.resetPasswordWithCallbacks = function (input, onSuccess, onFail) {
        var _this = this;
        var url_ = this.baseUrl + '/api/services/app/Account/ResetPassword';
        url_ = url_.replace(/[?&]$/, '');
        var content_ = JSON.stringify(input);
        abp.ajax.request({
            url: url_,
            method: 'post',
            data: content_,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then(function (xhr) {
            _this.processResetPasswordWithCallbacks(url_, xhr, onSuccess, onFail);
        }, function (xhr) {
            xhr = xhr.response;
            _this.processResetPasswordWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    };
    AccountServiceProxy.prototype.processResetPasswordWithCallbacks = function (_url, xhr, onSuccess, onFail) {
        try {
            var result = this.processResetPassword(xhr);
            if (onSuccess !== undefined) {
                onSuccess(result);
            }
        }
        catch (e) {
            if (onFail !== undefined) {
                onFail(e, 'http_service_exception');
            }
        }
    };
    AccountServiceProxy.prototype.sendEmailActivationLinkWithCallbacks = function (input, onSuccess, onFail) {
        var _this = this;
        var url_ = this.baseUrl + '/api/services/app/Account/SendEmailActivationLink';
        url_ = url_.replace(/[?&]$/, '');
        var content_ = JSON.stringify(input);
        abp.ajax.request({
            url: url_,
            method: 'post',
            data: content_,
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(function (xhr) {
            _this.processSendEmailActivationLinkWithCallbacks(url_, xhr, onSuccess, onFail);
        }, function (xhr) {
            xhr = xhr.response;
            _this.processSendEmailActivationLinkWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    };
    AccountServiceProxy.prototype.processSendEmailActivationLinkWithCallbacks = function (_url, xhr, onSuccess, onFail) {
        try {
            var result = this.processSendEmailActivationLink(xhr);
            if (onSuccess !== undefined) {
                onSuccess(result);
            }
        }
        catch (e) {
            if (onFail !== undefined) {
                onFail(e, 'http_service_exception');
            }
        }
    };
    AccountServiceProxy.prototype.activateEmailWithCallbacks = function (input, onSuccess, onFail) {
        var _this = this;
        var url_ = this.baseUrl + '/api/services/app/Account/ActivateEmail';
        url_ = url_.replace(/[?&]$/, '');
        var content_ = JSON.stringify(input);
        abp.ajax.request({
            url: url_,
            method: 'post',
            data: content_,
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(function (xhr) {
            _this.processActivateEmailWithCallbacks(url_, xhr, onSuccess, onFail);
        }, function (xhr) {
            xhr = xhr.response;
            _this.processActivateEmailWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    };
    AccountServiceProxy.prototype.processActivateEmailWithCallbacks = function (_url, xhr, onSuccess, onFail) {
        try {
            var result = this.processActivateEmail(xhr);
            if (onSuccess !== undefined) {
                onSuccess(result);
            }
        }
        catch (e) {
            if (onFail !== undefined) {
                onFail(e, 'http_service_exception');
            }
        }
    };
    AccountServiceProxy.prototype.impersonateWithCallbacks = function (input, onSuccess, onFail) {
        var _this = this;
        var url_ = this.baseUrl + '/api/services/app/Account/Impersonate';
        url_ = url_.replace(/[?&]$/, '');
        var content_ = JSON.stringify(input);
        abp.ajax.request({
            url: url_,
            method: 'post',
            data: content_,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then(function (xhr) {
            _this.processImpersonateWithCallbacks(url_, xhr, onSuccess, onFail);
        }, function (xhr) {
            xhr = xhr.response;
            _this.processImpersonateWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    };
    AccountServiceProxy.prototype.processImpersonateWithCallbacks = function (_url, xhr, onSuccess, onFail) {
        try {
            var result = this.processImpersonate(xhr);
            if (onSuccess !== undefined) {
                onSuccess(result);
            }
        }
        catch (e) {
            if (onFail !== undefined) {
                onFail(e, 'http_service_exception');
            }
        }
    };
    AccountServiceProxy.prototype.backToImpersonatorWithCallbacks = function (onSuccess, onFail) {
        var _this = this;
        var url_ = this.baseUrl + '/api/services/app/Account/BackToImpersonator';
        url_ = url_.replace(/[?&]$/, '');
        abp.ajax.request({
            url: url_,
            method: 'post',
            headers: {
                Accept: 'application/json'
            }
        }).then(function (xhr) {
            _this.processBackToImpersonatorWithCallbacks(url_, xhr, onSuccess, onFail);
        }, function (xhr) {
            xhr = xhr.response;
            _this.processBackToImpersonatorWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    };
    AccountServiceProxy.prototype.processBackToImpersonatorWithCallbacks = function (_url, xhr, onSuccess, onFail) {
        try {
            var result = this.processBackToImpersonator(xhr);
            if (onSuccess !== undefined) {
                onSuccess(result);
            }
        }
        catch (e) {
            if (onFail !== undefined) {
                onFail(e, 'http_service_exception');
            }
        }
    };
    AccountServiceProxy.prototype.switchToLinkedAccountWithCallbacks = function (input, onSuccess, onFail) {
        var _this = this;
        var url_ = this.baseUrl + '/api/services/app/Account/SwitchToLinkedAccount';
        url_ = url_.replace(/[?&]$/, '');
        var content_ = JSON.stringify(input);
        abp.ajax.request({
            url: url_,
            method: 'post',
            data: content_,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then(function (xhr) {
            _this.processSwitchToLinkedAccountWithCallbacks(url_, xhr, onSuccess, onFail);
        }, function (xhr) {
            xhr = xhr.response;
            _this.processSwitchToLinkedAccountWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    };
    AccountServiceProxy.prototype.processSwitchToLinkedAccountWithCallbacks = function (_url, xhr, onSuccess, onFail) {
        try {
            var result = this.processSwitchToLinkedAccount(xhr);
            if (onSuccess !== undefined) {
                onSuccess(result);
            }
        }
        catch (e) {
            if (onFail !== undefined) {
                onFail(e, 'http_service_exception');
            }
        }
    };
    return AccountServiceProxy;
}());
export { AccountServiceProxy };
